module.exports = __webpack_public_path__ + "static/apple-banner-192b0552c0d24383348e7523d0e83bd1.png";